"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function defaultUserAgent(packageName, packageVersion) {
  var originUserAgent = typeof navigator !== "undefined" && typeof navigator.userAgent === "string" ? navigator.userAgent : "";
  return "aws-sdk-js-v3-" + packageName + "/" + packageVersion + " " + originUserAgent;
}

exports.defaultUserAgent = defaultUserAgent;